<style>
.mysql_tables .v-navigation-drawer > .v-list .v-list__tile {
    font-weight: normal !important;
}
.mysql_tables .tile {
    margin: 0px;
    border-radius: 4px;
}
.mysql_tables .tile:first-child {
    margin-top: 8px;
}
.mysql_tables .v-list__tile {
    height: 28px !important;
}
.mysql_tables .v-list__tile--active {
    background: #757575 !important;
    color: #fff !important;
}
</style>

<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-tooltip>
                                <template slot="activator">
                                    <v-btn icon @mouseup.left="dbSyncDatabase()">
                                        <v-icon>storage</v-icon>
                                    </v-btn>
                                </template>
                                {{ $t("lang.sync") }}
                            </bc-tooltip>
                            <bc-btn-refresh @invoke-method="dbGetTables()" permanent></bc-btn-refresh>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-container grid-list-xl>
                    <v-layout row :wrap="$bp.smallScreen">
                        <bc-search-list
                            :items="sql_tables"
                            :selected_id="selected_table_id"
                            :filter="searchFilter"
                            :clickMethod="selectTable"
                            item-value="table_id"
                            item-text="table_name"
                        ></bc-search-list>
                        <v-divider vertical class="mt-0 mb-0" inset v-if="!$bp.smallScreen"></v-divider>
                        <v-flex xs12 md9 lg10 pb-0 :pr-0="!$bp.smallScreen" :pl-4="!$bp.smallScreen" align-self-start>
                            <v-card elevation="0">
                                <v-card-text>
                                    <vue-perfect-scrollbar
                                        class="scroll-area"
                                        :style="$bp.xs ? null : 'max-height: calc(100vh - 260px); min-height: calc(100vh - 260px)'"
                                    >
                                        <v-form ref="formSqlTable">
                                            <v-data-table
                                                :headers="headers"
                                                :items="sql_table.sql_fields"
                                                hide-actions
                                                :no-data-text="$t('lang.no_data_available')"
                                            >
                                                <template slot="items" slot-scope="props">
                                                    <td class="text-center">
                                                        <v-btn icon @click="openAllRelationships(props.item)">
                                                            <v-icon
                                                                small
                                                                :color="
                                                                    props.item.sql_fields_relations && props.item.sql_fields_relations.length != 0
                                                                        ? 'red'
                                                                        : 'blue-grey lighten-5'
                                                                "
                                                            >
                                                                device_hub
                                                            </v-icon>
                                                        </v-btn>
                                                    </td>
                                                    <td class="pr-2">
                                                        <v-text-field
                                                            v-model="props.item.name"
                                                            :counter="showCounter(props.item.name, 'sql_field.name')"
                                                            :rules="ifValid('sql_fields.name')"
                                                        ></v-text-field>
                                                    </td>
                                                    <td class="px-2">
                                                        <v-text-field
                                                            v-model="props.item.alias"
                                                            :counter="showCounter(props.item.alias, 'sql_field.alias')"
                                                            :rules="ifValid('sql_fields.alias')"
                                                        ></v-text-field>
                                                    </td>
                                                    <td class="px-2">
                                                        <bc-autocomplete
                                                            v-model="props.item.type"
                                                            :items="FieldTypes"
                                                            item-text="item"
                                                            item-value="item"
                                                            :rules="ifValid('sql_fields.type')"
                                                            single-line
                                                        ></bc-autocomplete>
                                                    </td>
                                                    <td class="px-2">
                                                        <v-text-field
                                                            v-model="props.item.length"
                                                            :counter="showCounter(props.item.length, 'sql_field.length')"
                                                            :rules="ifValid('sql_fields.length')"
                                                        ></v-text-field>
                                                    </td>
                                                    <td class="px-2">
                                                        <v-text-field
                                                            v-model="props.item.default_value"
                                                            readonly
                                                            :counter="showCounter(props.item.default_value, 'sql_field.default_value')"
                                                            :rules="ifValid('sql_fields.default_value')"
                                                        ></v-text-field>
                                                    </td>
                                                    <td class="px-2">
                                                        <v-text-field
                                                            v-model="props.item.rules"
                                                            :counter="showCounter(props.item.rules, 'sql_field.form_rules')"
                                                            :rules="ifValid('sql_fields.form_rules')"
                                                        ></v-text-field>
                                                    </td>
                                                    <td class="text-center">
                                                        <v-checkbox
                                                            true-value="1"
                                                            false-value="0"
                                                            hide-details
                                                            class="justify-center"
                                                            v-model="props.item.fillable"
                                                        ></v-checkbox>
                                                    </td>
                                                    <td class="text-center">
                                                        <v-checkbox
                                                            true-value="1"
                                                            false-value="0"
                                                            hide-details
                                                            class="justify-center"
                                                            v-model="props.item.protected"
                                                        ></v-checkbox>
                                                    </td>
                                                    <td class="text-center">
                                                        <v-checkbox
                                                            true-value="1"
                                                            false-value="0"
                                                            hide-details
                                                            class="justify-center"
                                                            v-model="props.item.is_hidden"
                                                        ></v-checkbox>
                                                    </td>
                                                    <td class="text-center">
                                                        <v-checkbox
                                                            true-value="1"
                                                            false-value="0"
                                                            hide-details
                                                            class="justify-center"
                                                            v-model="props.item.is_searchable"
                                                        ></v-checkbox>
                                                    </td>
                                                </template>
                                            </v-data-table>
                                        </v-form>
                                    </vue-perfect-scrollbar>
                                </v-card-text>

                                <v-card-actions v-if="sql_table.sql_fields && sql_table.sql_fields.length != 0">
                                    <v-spacer></v-spacer>
                                    <v-btn @click="closeSqlTables" flat>{{ $t("lang.cancel") }}</v-btn>
                                    <v-btn color="success" @click="saveSqlTables">{{ $t("lang.save") }}</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </v-container>

        <!-- RELATIONSHIPS DIALOG START -->
        <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition" overlay="false" scrollable>
            <v-card>
                <v-toolbar color="primary" dark>
                    <v-btn icon @click.native="dialog = false" dark>
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ dialogTitle }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items> </v-toolbar-items>
                </v-toolbar>
                <v-card-text>
                    <vue-perfect-scrollbar class="scroll-area" :style="$bp.xs ? null : 'max-height: calc(100vh - 160px);'">
                        <v-data-table
                            :headers="relationship_headers"
                            :items="relationships.sql_fields_relations || []"
                            item-key="order_detail_id"
                            :no-data-text="$t('lang.no_results_matching')"
                            hide-actions
                            class="elevation-3"
                        >
                            <v-form ref="formSqlRelationships"></v-form>
                            <template slot="items" slot-scope="props">
                                <tr class="clickable" @mouseup.left="openSqlRelationshipForm(props.item)">
                                    <td>
                                        {{ props.item.name }}
                                    </td>
                                    <td>
                                        {{ relationType(props.item.relation_type) }}
                                    </td>
                                    <td>
                                        {{ props.item.foreign_table_field }}
                                    </td>
                                    <td>
                                        {{ props.item.foreign_object_name }}
                                    </td>
                                    <td>
                                        {{ props.item.foreign_model_name }}
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </vue-perfect-scrollbar>
                </v-card-text>

                <v-card-actions v-if="sql_table.length != 0">
                    <v-spacer></v-spacer>
                    <v-btn color="info" @click="openSqlRelationshipForm">{{ $t("lang.add") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- RELATIONSHIPS DIALOG END -->

        <!-- ADD/EDIT RELATIONSHIPS DIALOG START -->
        <bc-dialog :value="sql_relationship_dialog">
            <v-card>
                <v-form ref="form_sql_relationship">
                    <v-card-title>
                        <span class="headline">{{ relationship.relation_id ? $t("lang.edit_sql_relationship") : $t("lang.add_sql_relationship") }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            action="closeSqlRelationshipDialog"
                            :dialog-status="sql_relationship_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-container grid-list-form>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <bc-autocomplete
                                        v-model="relationship.field_id"
                                        :items="sql_table.sql_fields || []"
                                        item-text="name"
                                        item-value="field_id"
                                        :label="`${$t('lang.field_id')} *`"
                                        :rules="ifValid('sql_relationships.field_id')"
                                        single-line
                                    ></bc-autocomplete>
                                </v-flex>
                                <v-flex xs12>
                                    <bc-select
                                        v-model="relationship.relation_type"
                                        :items="RelationType"
                                        item-text="text"
                                        item-value="value"
                                        :rules="ifValid('sql_relationships.relation_type')"
                                        single-line
                                    ></bc-select>
                                </v-flex>
                                <v-flex xs12>
                                    <bc-autocomplete
                                        v-model="relationship.reference_column_id"
                                        :items="sql_fields || []"
                                        item-text="table_field"
                                        item-value="field_id"
                                        :rules="ifValid('sql_relationships.reference_column_id')"
                                        single-line
                                    ></bc-autocomplete>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                        v-model="relationship.foreign_object_name"
                                        :label="`${$t('lang.foreign_object_name')} *`"
                                        :counter="showCounter(relationship.foreign_object_name, 'sql_relationships.foreign_object_name')"
                                        :rules="ifValid('sql_relationships.foreign_object_name')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                        v-model="relationship.foreign_model_name"
                                        :label="`${$t('lang.foreign_model_name')} *`"
                                        :counter="showCounter(relationship.foreign_model_name, 'sql_relationships.foreign_model_name')"
                                        :rules="ifValid('sql_relationships.foreign_model_name')"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn v-if="relationship.relation_id" color="error" @mouseup.left="$refs.delete_sql_relationships.openDialog()">{{
                            $t("lang.delete")
                        }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="closeSqlRelationshipDialog()">{{ $t("lang.cancel") }}</v-btn>
                        <v-btn color="success" @click="saveSqlRelationships">{{ $t("lang.save") }}</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </bc-dialog>
        <delete-confirmation-dialog
            ref="delete_sql_relationships"
            :heading="$t('lang.delete_sql_relationship')"
            :message="$t('lang.confirm_delete_message')"
            @onConfirm="deleteSqlRelationships(relationship.relation_id)"
        ></delete-confirmation-dialog>
        <!-- ADD/EDIT RELATIONSHIPS DIALOG END -->
    </div>
</template>

<script>
import { store } from "Store/store";
import { mapState, mapActions, mapMutations } from "vuex";
import app from "Main";

export default {
    data() {
        return {
            headers: [
                { sortable: false, width: "5%" },
                { text: this.$t("lang.name"), sortable: false, width: "12%" },
                { text: this.$t("lang.alias"), sortable: false, width: "12%" },
                { text: this.$t("lang.type"), sortable: false, width: "12%" },
                { text: this.$t("lang.length"), sortable: false, width: "5%" },
                { text: this.$t("lang.default_value"), sortable: false, width: "9%" },
                { text: this.$t("lang.rules"), sortable: false },
                { text: this.$t("lang.fillable"), sortable: false, width: "5%", align: "center" },
                { text: this.$t("lang.protected"), sortable: false, width: "5%", align: "center" },
                { text: this.$t("lang.is_hidden"), sortable: false, width: "5%", align: "center" },
                { text: this.$t("lang.is_searchable"), sortable: false, width: "5%", align: "center" },
            ],
            relationship_headers: [
                { text: this.$t("lang.field_id"), sortable: false, width: "20%" },
                { text: this.$t("lang.relation_type"), sortable: false, width: "10%" },
                { text: this.$t("lang.reference_column_id"), sortable: false, width: "25%" },
                { text: this.$t("lang.foreign_object_name"), sortable: false, width: "20%" },
                { text: this.$t("lang.foreign_model_name"), sortable: false, width: "25%" },
            ],
            mobileList: [{ title: this.$t("lang.refresh"), action: "dbGetTables" }],
            dbGetTables: _.debounce(this.refresh, 1500, { maxWait: 1500, leading: true, trailing: false }),
            dbSyncDatabase: _.debounce(this.syncDatabase, 1500, { maxWait: 1500, leading: true, trailing: false }),
            dialog: false,
            dialogTitle: "",
            sql_relationship_dialog: false,
            tables: [],
            relationships: [],
            relationship: {},
            sql_table: [],
            selected_table_id: null,
            searchFilter: "",
            new_relation: {
                field_id: "",
                relation_type: "0",
                reference_column_id: "",
                foreign_object_name: "",
                foreign_model_name: "",
                is_user_def: "1",
            },
            RelationType: [{ value: "0", text: "has_one" }, { value: "1", text: "has_many" }, { value: "2", text: "has_many_pivot" }],
            FieldTypes: [
                "bigint",
                "blob",
                "char",
                "date",
                "datetime",
                "decimal",
                "enum",
                "float",
                "int",
                "longtext",
                "mediumtext",
                "smallint",
                "text",
                "timestamp",
                "tinyint",
                "varchar",
            ],
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchSqlTables", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.sql_tables) {
                    next((vm) => {
                        vm.$store.commit("toggleMainMenu", false);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchSqlTables({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.sql_tables) {
                this.$store.commit("toggleMainMenu", false);
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.sql_tables.sql_tables_filter,
            page: (state) => state.sql_tables.page,
            rules_sql_tables: (state) => state.sql_tables.rules_sql_tables,
            rules_sql_fields: (state) => state.sql_fields.rules_sql_fields,
            rules_sql_relationships: (state) => state.sql_relationships.rules_sql_relationships,
            sql_table_status_options: (state) => state.settings.sql_table_status_options,
            sql_tables: (state) => state.sql_tables.sql_tables,
            sql_fields: (state) => state.sql_fields.sql_fields,
            sql_field_options: (state) => state.sql_fields.sql_field_options,
        }),
        isActiveMenu() {
            return (table_id) => (table_id == this.selected_table_id ? true : false);
        },
        relationType() {
            return (type) => {
                return this.RelationType.find((t) => t.value == type).text;
            };
        },
        resultQuery() {
            console.log("result 1");
            if (this.searchFilter) {
                return this.sql_tables.filter((item) => {
                    return this.searchFilter
                        .toLowerCase()
                        .split(" ")
                        .every((v) => item.table_name.toLowerCase().includes(v));
                });
            } else {
                return this.sql_tables;
            }
        },
    },
    methods: {
        ...mapActions([
            "fetchSqlTables",
            "fetchSqlTable",
            "saveSqlTable",
            "deleteSqlTable",
            "syncSql",
            "saveSqlField",
            "fetchSqlFields",
            "fetchSqlRelationships",
            "saveSqlRelationship",
            "deleteSqlRelationship",
        ]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        async selectTable(item) {
            if (item) {
                this.startLoader();

                await this.fetchSqlTable({
                    id: item.table_id,
                })
                    .then((data) => {
                        if (typeof data !== "undefined" && data.sql_table) {
                            this.selected_table_id = item.table_id;
                            this.sql_table = this.assignObj2(data.sql_table, this.rules_sql_tables);
                        } else {
                            this.selected_table_id = null;
                            this.sql_table = [];
                        }
                    })
                    .finally(() => this.finishLoader());
            }
        },
        saveSqlTables() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formSqlTable")) {
                    let body = this.prepForm(this.sql_table, this.rules_sql_tables);

                    this.saveSqlTable({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.sql_table) {
                            //this.$router.push({ name: "sql_table", params: { id: data.sql_table.table_id } });
                        } else {
                        }
                    });
                }
            });
        },
        closeSqlTables() {
            this.selected_table_id = null;
            this.sql_table = [];
        },
        syncDatabase() {
            this.startLoader();

            this.syncSql({})
                .then((data) => {
                    let table = this.sql_tables.find((tables) => tables.table_id == this.selected_table_id);
                    if (table) {
                        this.sql_table = table;
                    } else {
                        this.selected_table_id = null;
                        this.sql_table = [];
                    }
                })
                .finally(() => this.finishLoader());
        },
        refresh() {
            this.startLoader();

            this.fetchSqlTables({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data !== "undefined" && data.sql_tables) {
                        this.fetchSqlTable({
                            id: this.selected_table_id,
                        }).then((data) => {
                            if (typeof data !== "undefined" && data.sql_table) {
                                this.selected_table_id = data.sql_table.table_id;
                                this.sql_table = this.assignObj2(data.sql_table, this.rules_sql_tables);
                            } else {
                                this.selected_table_id = null;
                                this.sql_table = [];
                            }
                        });

                        this.$store.commit("toggleMainMenu", false);
                    }
                })
                .finally(() => this.finishLoader(true));
        },
        openAllRelationships(item) {
            if (item) {
                this.startLoader();

                if (!item.sql_fields_relations || item.sql_fields_relations.length == 0) item.sql_fields_relations = [];

                //this.fetchSqlFields({ body: { table_id: item.table_id } });
                this.dialogTitle = item.table_name + "." + item.name;
                this.relationships = this.assignObj2(item, this.rules_sql_relationships);
                this.$nextTick(() => {
                    this.dialog = true;
                    this.finishLoader();
                });
            }
        },
        openSqlRelationshipForm(item = null) {
            if (item != null) {
                if (this.$refs.form_sql_relationship) item ? this.$refs.form_sql_relationship.resetValidation() : this.$refs.form_sql_relationship.reset();
                console.log(item);
                this.$nextTick(() => {
                    this.relationship = item != null ? this.assignObj2(item, this.rules_sql_relationships) : {};
                    this.sql_relationship_dialog = true;
                });
            } else {
                if (this.$refs.form_sql_relationship) item ? this.$refs.form_sql_relationship.resetValidation() : this.$refs.form_sql_relationship.reset();
                this.$nextTick(() => {
                    this.relationship = this.assignObj2(this.new_relation, this.rules_sql_relationships);
                    this.sql_relationship_dialog = true;
                });
            }
        },
        closeSqlRelationshipDialog() {
            this.sql_relationship_dialog = false;
            this.$refs.delete_sql_relationships.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        saveSqlRelationships() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_sql_relationship")) {
                    let body = this.prepForm(this.relationship, this.rules_sql_relationships);
                    console.log(this.relationship);
                    this.saveSqlRelationship({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            //this.getSqlRelationships();
                            if (this.relationship.relation_id) {
                                let index = this.relationships.sql_fields_relations.map((item) => item.relation_id).indexOf(body.relation_id);
                                this.relationships.sql_fields_relations.splice(index, 1, data.sql_fields_relations);
                            } else {
                                this.relationships.sql_fields_relations.push(data.sql_fields_relations);
                            }
                            this.closeSqlRelationshipDialog();
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteSqlRelationships(id = null) {
            let index = this.relationships.sql_fields_relations.map((item) => item.relation_id).indexOf(id);

            this.deleteSqlRelationship({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.relationships.sql_fields_relations.splice(index, 1);
                    //this.getSqlRelationships();
                    this.closeSqlRelationshipDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },
    },
    async created() {
        //this.fetchSqlFields({ body: { table_id: this.$route.params.id } });
        if (this.sql_tables.length == 0) await this.fetchSqlTables({ body: JSON.parse(JSON.stringify(this.$route.query)) });
        if (this.sql_fields.length == 0) await this.fetchSqlFields({});
    },
};
</script>
